import {Tooltip} from 'platform/components';
import {Heading, HStack, Icon, Show, Text, ThemeIconKey, VStack} from 'platform/foundation';

import {isNotNil} from 'ramda';

import {Nullish, suffixTestId, TestIdProps} from 'shared/web';

import {AvatarIcon} from '../../../components/AvatarIcon/AvatarIcon';
import {Badge} from '../../../components/Badge/Badge';
import {BadgeLetter} from '../../Specification/utils/getBadgeLetter';

interface ElectricalItemProps extends TestIdProps {
  value: string | number;
  categoryTitle: string;
  icon: ThemeIconKey;
  labelTooltip?: string | Nullish;
  badge?: BadgeLetter | Nullish;
}

export function ElectricalItem(props: ElectricalItemProps) {
  const valueIsNotEmptyString = props.value !== '';
  return (
    <HStack spacing={4} align="center">
      <AvatarIcon icon={props.icon} iconColor="fill.electroIconFg" bgColor="fill.electroIconBg" />
      <VStack spacing={props.categoryTitle && valueIsNotEmptyString ? 1 : 0}>
        <HStack spacing={1}>
          <Text data-testid={suffixTestId('category', props)} size="xSmall" color="secondary">
            {props.categoryTitle}
          </Text>
          {props.labelTooltip && (
            <Tooltip label={props.labelTooltip}>
              <Icon value="action/info" size={4} color="text.tertiary" />
            </Tooltip>
          )}
        </HStack>
        <HStack spacing={2} align="center">
          <Heading data-testid={suffixTestId('value', props)} size={4}>
            {String(props.value)}
          </Heading>
          <Show when={isNotNil(props.badge)}>
            <Badge variant={props.badge!} />
          </Show>
        </HStack>
      </VStack>
    </HStack>
  );
}
